/** @jsx jsx */
import { VideoDialog } from '@datacamp/exercise-instruction-pane';
import Button from '@datacamp/waffles-button';
import { VideoCameraIcon } from '@datacamp/waffles-icons';
import { jsx } from '@emotion/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const VideoResourceButton = _ref => {
  let {
    videoUrl
  } = _ref;
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const openVideoDialog = React.useCallback(() => setVideoDialogOpen(true), []);
  const closeVideoDialog = React.useCallback(() => setVideoDialogOpen(false), []);
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'RemoteDesktopExercise'
  });
  return jsx(React.Fragment, null, jsx(Button, {
    dataAttributes: {
      cy: 'conversational-interface-rewatch-demo'
    },
    onClick: openVideoDialog,
    size: "small"
  }, ["".concat(t('VideoResourceButton.button'), " "), jsx(VideoCameraIcon, {
    key: "video-camera-icon"
  })]), videoDialogOpen && jsx(VideoDialog, {
    onExit: closeVideoDialog,
    videoUrl: videoUrl
  }));
};